/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";
import * as Models from "../models";
import * as Mappers from "../models/pharmacyTaxNoteDocumentMappers";
import * as Parameters from "../models/parameters";
import { PolandPharmacyRxAPIContext } from "../polandPharmacyRxAPIContext";

/** Class representing a PharmacyTaxNoteDocument. */
export class PharmacyTaxNoteDocument {
  private readonly client: PolandPharmacyRxAPIContext;

  /**
   * Create a PharmacyTaxNoteDocument.
   * @param {PolandPharmacyRxAPIContext} client Reference to the service client.
   */
  constructor(client: PolandPharmacyRxAPIContext) {
    this.client = client;
  }

  /**
   * @param [options] The optional parameters
   * @returns Promise<Models.PharmacyTaxNoteDocumentAllForPharmacyResponse>
   */
  allForPharmacy(options?: Models.PharmacyTaxNoteDocumentAllForPharmacyOptionalParams): Promise<Models.PharmacyTaxNoteDocumentAllForPharmacyResponse>;
  /**
   * @param callback The callback
   */
  allForPharmacy(callback: msRest.ServiceCallback<Models.PharmacyTaxNoteDocumentDtoPagedResult>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  allForPharmacy(options: Models.PharmacyTaxNoteDocumentAllForPharmacyOptionalParams, callback: msRest.ServiceCallback<Models.PharmacyTaxNoteDocumentDtoPagedResult>): void;
  allForPharmacy(options?: Models.PharmacyTaxNoteDocumentAllForPharmacyOptionalParams | msRest.ServiceCallback<Models.PharmacyTaxNoteDocumentDtoPagedResult>, callback?: msRest.ServiceCallback<Models.PharmacyTaxNoteDocumentDtoPagedResult>): Promise<Models.PharmacyTaxNoteDocumentAllForPharmacyResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      allForPharmacyOperationSpec,
      callback) as Promise<Models.PharmacyTaxNoteDocumentAllForPharmacyResponse>;
  }

  /**
   * @param id
   * @param [options] The optional parameters
   * @returns Promise<Models.PharmacyTaxNoteDocumentGetFileResponse>
   */
  getFile(id: string, options?: msRest.RequestOptionsBase): Promise<Models.PharmacyTaxNoteDocumentGetFileResponse>;
  /**
   * @param id
   * @param callback The callback
   */
  getFile(id: string, callback: msRest.ServiceCallback<void>): void;
  /**
   * @param id
   * @param options The optional parameters
   * @param callback The callback
   */
  getFile(id: string, options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<void>): void;
  getFile(id: string, options?: msRest.RequestOptionsBase | msRest.ServiceCallback<void>, callback?: msRest.ServiceCallback<void>): Promise<Models.PharmacyTaxNoteDocumentGetFileResponse> {
    return this.client.sendOperationRequest(
      {
        id,
        options
      },
      getFileOperationSpec,
      callback) as Promise<Models.PharmacyTaxNoteDocumentGetFileResponse>;
  }
}

// Operation Specifications
const serializer = new msRest.Serializer(Mappers);
const allForPharmacyOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "portal/PharmacyTaxNoteDocument",
  queryParameters: [
    Parameters.pharmacyId1,
    Parameters.sieveFilters,
    Parameters.sieveSorts,
    Parameters.sievePage,
    Parameters.sievePageSize
  ],
  responses: {
    200: {
      bodyMapper: Mappers.PharmacyTaxNoteDocumentDtoPagedResult
    },
    default: {}
  },
  serializer
};

const getFileOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "portal/PharmacyTaxNoteDocument/{id}",
  urlParameters: [
    Parameters.id3
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Stream"
        }
      }
    },
    default: {}
  },
  serializer
};
